export default Object.freeze({ SET_SUBMISSION: "SET_SUBMISSION" });
